import { render, staticRenderFns } from "./lhc_ball.vue?vue&type=template&id=7f0965d0&scoped=true"
import script from "./lhc_ball.vue?vue&type=script&lang=js"
export * from "./lhc_ball.vue?vue&type=script&lang=js"
import style0 from "./lhc_ball.vue?vue&type=style&index=0&id=7f0965d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0965d0",
  null
  
)

export default component.exports